import React from 'react';
import { Navigate, useOutlet, useLocation } from 'react-router-dom';

import useStore from '../states/store';

export default function PublicLayout() {
  const { pathname } = useLocation();
  const outlet = useOutlet();
  const token = useStore((state) => state.token);
  const auth = useStore((state) => state.auth);

  if (token && pathname !== '/access-redirect') {
    switch (auth.designation) {
      case 'HTAM':
        return <Navigate to='/dashboard/hcp' replace />;
      case 'SD':
        return <Navigate to='/dashboard/hcp' replace />;
      case 'NSM-HOSPITAL':
        return <Navigate to='/dashboard/hcp' replace />;
      case 'HTAR':
        return <Navigate to='/cwp-approval' replace />;
      case 'DAM':
        return <Navigate to='/report/field-engagement' replace />;
      case 'CNC-MANAGER':
        return <Navigate to='/report/field-engagement' replace />;
      case 'CNC-ANALYST':
        return <Navigate to='/dashboard/client-call-out' replace />;
      case 'CNC-ADMIN':
        return <Navigate to='/dashboard/client-call-out' replace />;
      default:
        return <Navigate to='/dashboard/crm' replace />;
    }
  }

  return <div>{outlet}</div>;
}
